import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./index.scss";
import frFlag from "../../../assets/images/fr.png";
import ukFlag from "../../../assets/images/uk.png";
import luxFlag from "../../../assets/images/lux.png";

import SimulationService from "../../../service/simulation.service";
const simulationService = new SimulationService();

const StepOneForm = () => {
  const [selectedCountry, setSelectedCountry] = useState("FR");
  const [step, setStep] = useState(1);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    tjh: "",
    jours: "",
    fraisPro: "",
    repas: "",
    autresFrais: 0,
  });

  const [result, setResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [contactEmail, setContactEmail] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateStep = () => {
    if (step === 1) {
      if (!formData.tjh || !formData.jours || !formData.fraisPro) {
        toast.error("Veuillez remplir tous les champs de l'étape 1");
        return false;
      }
    } else if (step === 2) {
      if (!formData.repas) {
        toast.error("Veuillez remplir tous les champs de l'étape 2");
        return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    if (!validateStep()) return;
    setStep(step + 1);
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateStep()) return;

    const { tjh, jours, fraisPro, repas, autresFrais } = formData;

    const data = {
      chiffreAffairesHT: tjh * jours,
      fraisProfessionnels: fraisPro,
      chargementMission: repas,
      autresPrelevements: autresFrais ?? 0, // Valeur par défaut
      configFrId: "686f7852aa2568ab72c11d4d",
      configUkId: "686f8985db554e6ca24ddfef",
      configLuxId: "686fa90b9f3199bea05e976d",
    };

    setSaving(true);

    try {
      const res = await simulationService.simulationFusion(data);
      setResult(res.data);
      console.log("Simulation fusionnée :", res.data);
      toast.success("Simulation envoyée avec succès !");
      setStep(3);
    } catch (err) {
      console.error("Erreur lors de la simulation fusionnée :", err);
      toast.error("Erreur lors de l’envoi de la simulation");
    } finally {
      setSaving(false);
    }
  };
  const handleContactSubmit = async () => {
    if (!contactEmail || !/\S+@\S+\.\S+/.test(contactEmail)) {
      toast.error("Veuillez entrer un email valide");
      return;
    }
    setSaving(true);
    const data = {
      email: contactEmail,
      chiffreAffairesHT: result.fr.chiffreAffairesHT,
      fraisProfessionnels: Number(result.fr.fraisProfessionnels),
      chargementMission: Number(result.fr.chargementMission),
      autresPrelevements: result.fr.autresPrelevements,

      simulationFr: {
        configFrId: result.fr.configFrId,
        fraisGestionPct: result.fr.fraisGestionPct,
        tauxChargesSalarialesPct: result.fr.tauxChargesSalarialesPct,
        fraisGestionEuro: result.fr.fraisGestionEuro,
        baseDisponible: result.fr.baseDisponible,
        salaireBrut: result.fr.salaireBrut,
        salaireNet: result.fr.salaireNet,
        salaireNetOptimise: result.fr.salaireNetOptimise,
      },

      simulationUk: {
        configUkId: result.uk.configUkId,
        fraisGestionPct: result.uk.fraisGestionPct,
        tauxChargesPatronalesPct: result.uk.tauxChargesPatronalesPct,
        tauxChargesSalarialesPct: result.uk.tauxChargesSalarialesPct,
        fraisGestionEuro: result.uk.fraisGestionEuro,
        baseDisponible: result.uk.baseDisponible,
        salaireBrut: result.uk.salaireBrut,
        chargesPatronalesEuro: result.uk.chargesPatronalesEuro,
        chargesSalarialesEuro: result.uk.chargesSalarialesEuro,
        salaireNet: result.uk.salaireNet,
        salaireNetOptimise: result.uk.salaireNetOptimise,
        pourcentageSalaireBrut: result.uk.pourcentageSalaireBrut,
      },

      simulationLux: {
        configLuxId: result.lux.configLuxId,
        fraisGestionPct: result.lux.fraisGestionPct,
        tauxChargesPatronalesPct: result.lux.tauxChargesPatronalesPct,
        tauxChargesSalarialesPct: result.lux.tauxChargesSalarialesPct,
        fraisGestionEuro: result.lux.fraisGestionEuro,
        baseDisponible: result.lux.baseDisponible,
        salaireBrut: result.lux.salaireBrut,
        chargesPatronalesEuro: result.lux.chargesPatronalesEuro,
        chargesSalarialesEuro: result.lux.chargesSalarialesEuro,
        salaireNet: result.lux.salaireNet,
        salaireNetOptimise: result.lux.salaireNetOptimise,
        pourcentageSalaireBrut: result.lux.pourcentageSalaireBrut,
      },
    };
    console.log("Données de contact :", data);

    try {
      let res;

      res = await simulationService.simulationSave(data);

      toast.success("Simulation envoyée avec succès !");
      setStep(3);
    } catch (err) {
      console.error("Erreur :", err);
      toast.error("Erreur lors de l’envoi de la simulation");
    } finally {
      setSaving(false);
    }

    // 👇 Ajouter une logique d’enregistrement si nécessaire ici
    toast.success("Merci ! Nous vous contacterons bientôt.");
    setShowModal(false);
    setContactEmail("");
  };

  return (
    <div className="step-one-section">
      <div className="step-one-container">
        {/* Drapeaux */}

        {/* Étape */}
        <div className="circle-step">{step}</div>

        <p className="description-text text-center">
          Notre simulateur est conçu pour vous offrir une première analyse de
          votre situation actuelle, identifier les leviers d'amélioration, et
          anticiper les résultats d’une collaboration avec notre équipe.
        </p>

        <Form className="step-form" onSubmit={handleSubmit}>
          {step === 1 && (
            <>
              <Form.Group className="mb-3">
                <Form.Control
                  type="number"
                  name="tjh"
                  value={formData.tjh}
                  onChange={handleChange}
                  placeholder="TJM"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="number"
                  name="jours"
                  value={formData.jours}
                  onChange={handleChange}
                  placeholder="Nombre de jours travaillés"
                />
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Control
                  type="number"
                  name="fraisPro"
                  value={formData.fraisPro}
                  onChange={handleChange}
                  placeholder="Frais Professionnels"
                />
              </Form.Group>
            </>
          )}

          {step === 2 && (
            <>
              <Form.Group className="mb-3">
                <Form.Control
                  type="number"
                  name="repas"
                  value={formData.repas}
                  onChange={handleChange}
                  placeholder="Charge Mission"
                />
              </Form.Group>
            </>
          )}

          {step === 3 && result && (
            <>
              <Form.Group className="mb-2">
                <Form.Label>Frais de Gestion (%)</Form.Label>
                <Form.Control
                  value={result?.fr?.fraisGestionPct + " %"}
                  disabled
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Taux Charges Salariales (%)</Form.Label>
                <Form.Control
                  value={result?.fr?.tauxChargesSalarialesPct + " %"}
                  disabled
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Frais de Gestion (€)</Form.Label>
                <Form.Control
                  value={result?.fr?.fraisGestionEuro + " €"}
                  disabled
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Base Disponible (€)</Form.Label>
                <Form.Control
                  value={result?.fr?.baseDisponible + " €"}
                  disabled
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Salaire Brut (€)</Form.Label>
                <Form.Control value={result?.fr?.salaireBrut + " €"} disabled />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Salaire Net (€)</Form.Label>
                <Form.Control value={result?.fr?.salaireNet + " €"} disabled />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Salaire Net Optimisé (€)</Form.Label>
                <Form.Control
                  value={result?.fr?.salaireNetOptimise + " €"}
                  disabled
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label> Taux de rentabilité au Royaume-Uni </Form.Label>
                <Form.Control
                  value={result?.uk?.pourcentageSalaireBrut + " %"}
                  disabled
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Taux de rentabilité au Luxembourg</Form.Label>
                <Form.Control
                  value={result?.lux?.pourcentageSalaireBrut + " %"}
                  disabled
                />
              </Form.Group>
            </>
          )}

          {/* Boutons */}
          <div className="form-actions d-flex justify-content-between gap-3">
            {step > 1 && step < 3 && (
              <button
                className="next-button p-2"
                type="button"
                onClick={handleBack}>
                Retour
              </button>
            )}
            {step === 1 && (
              <button
                className="next-button p-2"
                type="button"
                onClick={handleNext}>
                Suivant
              </button>
            )}
            {step === 2 && (
              <button
                className="next-button-1 p-2"
                type="submit"
                disabled={saving}>
                {saving ? "Envoi..." : "Terminer"}
              </button>
            )}
            {step === 3 && (
              <button
                className="next-button-1 p-2"
                type="button"
                onClick={() => setShowModal(true)}>
                Contactez-nous
              </button>
            )}
          </div>
        </Form>
      </div>

      {/* Modal Contact Email */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Entrez votre email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3 mt-3">
            <Form.Label>Adresse Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="ex: contact@exemple.com"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Fermer
          </Button>
          <Button className="btn-final" onClick={handleContactSubmit}>
            Envoyer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StepOneForm;
